import { RootState } from '../store';

export const selectExternalUrlsData = (state: RootState) =>
  state.externalUrlsReducer.externalUrls;

export const selectExternalUrlsError = (state: RootState) => ({
  error: state.externalUrlsReducer.error,
  message: state.externalUrlsReducer.errorMessage,
  details: state.externalUrlsReducer.errorDetails,
});
